const firebaseConfig = {
    apiKey: "AIzaSyCSS0xyEo8ROuGAxtVsnx97A7_fmPlpfRU",
    authDomain: "ema-jhon-ecommerce-app.firebaseapp.com",
    databaseURL: "https://ema-jhon-ecommerce-app.firebaseio.com",
    projectId: "ema-jhon-ecommerce-app",
    storageBucket: "ema-jhon-ecommerce-app.appspot.com",
    messagingSenderId: "426178472378",
    appId: "1:426178472378:web:b526a670326eef8c4bd583"
  };

export default firebaseConfig;